import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ProcessDataSource } from 'src/app/services/process.datasource';
import { ProcessService } from 'src/app/services/process.service';
import { UserService } from 'src/app/services/user.service';
import { YearService } from 'src/app/services/year.service';
import { environment } from "../../../../environments/environment";
@Component({
  selector: "rdf-stat-table-user-dec-activity",
  templateUrl: "./stat-table-user-dec-activity.component.html",
  styleUrls: ["./stat-table-user-dec-activity.component.css"],
})
export class StatTableUserDecActivityComponent implements OnInit {
  dataSource: ProcessDataSource
  @Input() displayedColumns;
  @Output() onDownloadStatistics = new EventEmitter<any>();
  displayedYears = []
  user: any;
  name: string;
  objectFilter = { internal: false, userDecActivity: true };
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  currentYear = new Date().getFullYear().toString()

  constructor(public yearService: YearService,
    public translate: TranslateService,
    private router: Router,
    public processService: ProcessService, public userService: UserService, public spinner: NgxSpinnerService) { 
    this.userService.getCurrentUser().subscribe(user => {
      this.user = user
      this.dataSource = new ProcessDataSource(this.processService)
      this.yearService.getList("year").subscribe(val => {
        val.forEach(element => {
          this.displayedYears.push(element.year)
        });
        if (val.length > 0) {
          setTimeout(() => {
            this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
            merge(this.sort.sortChange, this.paginator.page)
              .pipe(
                tap(() => this.loadProcessPage())
              )
              .subscribe();
          }, 1000)
        }
      });
    })
  }

  ngOnInit() {
  }

  advancedSearch(filter) {
    this.spinner.show()
    this.objectFilter = filter
    this.objectFilter['userDecActivity'] = true;
    this.loadProcessPage()
  }

  downloadUserDecActivity() {
    let headers = [
      {
        header: this.translate.instant("STATISTICS.TABLE_COLUMN_USERNAME"),
        key: "createdBy",
      },
      {
        header: this.translate.instant("STATISTICS.TABLE_COLUMN_NUMBER_OF_TAXPAYERS"),
        key: "numOfTaxPayers",
      },
      {
        header: this.translate.instant("STATISTICS.TABLE_COLUMN_NUMBER_OF_DECLARATIONS"),
        key: "numOfDeclarations",
      }
    ];
  
    this.spinner.show();
    this.processService
      .downloadUserDecActivityList(this.objectFilter, headers)
      .subscribe((data) => {
        this.spinner.hide();
        const blob = data;
        const file = new Blob([blob], {});
        const filename = "document_" + Date.now() + ".xlsx";
        saveAs(file, filename);
      });
  }

  loadProcessPage() {
    this.spinner.show();
    this.dataSource.loadUserDecActivityList(
      this.sort.direction, 
      this.sort.active, 
      this.paginator.pageIndex, 
      this.paginator.pageSize, 
      this.objectFilter, 
      this.spinner
    );
  }
}
